import appConfig from "@/config/appConfig";
import { Input, Select, Spin } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FiEdit, FiTrash, FiUserCheck, FiUserX } from "react-icons/fi";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { DataTable } from "@/components";
import { numberFormatter } from "@/utils";

const SubscriptionSummary = () => {
  const [subscriptionSummary, setSubscriptionSummary] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState({});
  const [searchText, setSerachText] = useState("");
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const getSubscriptionSummary = async () => {
    setIsLoading(true);
    try {
      const {
        data: { result, count },
      } = await axios.get(`/subscription/assign-plan/`, {
        withCredentials: true,
        params: { ...searchValue, searchText, unkown: true, page, limit },
      });
      setSubscriptionSummary(result);
      setTotal(count);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = appConfig.name + " - Customer Subscription Summary";
    getSubscriptionSummary();
  }, [page, limit, searchText]);

  const columns = [
    {
      title: "No.",
      render: (_, __, idx) => (page - 1) * limit + idx + 1,
      width: "60px",
      align: "center",
    },
    {
      title: "Business",
      render: (_, row) => (row?.business?.name ? `${row?.business?.name} (${row?.business?.id})` : "--"),
      // align: "center",
    },
    {
      title: "Plan Name",
      render: (_, row) => row?.name || "--",
      align: "center",
    },
    {
      title: "Duration",
      render: (_, row) => row?.duration || "--",
      align: "center",
    },
    {
      title: "Start Date",
      render: (_, row) => moment(row.startDate).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "End Date",
      render: (_, row) => moment(row.endDate).format("DD/MM/YYYY"),
      align: "center",
    },
    // {
    //   title: "Email",
    //   render: (_, row) => row?.emailNotificationType || "--",
    //   align: "center",
    // },
    {
      title: "SMS",
      render: (_, row) => (
        <div>
          {row?.smsNotificationType || "--"}
          {row?.smsNotificationType === "Yes" ? `(${row?.smsCount || 0})` : ""}
        </div>
      ),
      align: "center",
    },
    // {
    //   title: "Interval",
    //   render: (_, row) => row?.paymentInterval || "--",
    //   align: "center",
    // },
    {
      title: "Total Price",
      render: (_, row) =>
        numberFormatter((row?.deviceCount || 0) * (row?.price || 0) * moment(row.endDate).diff(row.startDate, "month")),
      align: "center",
    },
    {
      title: "Date Assigned",
      render: (_, row) => moment(row.createdAt).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "Status",
      render: (_, row) => (
        <div>
          {row.isActive ? (
            <span className="badge text-bg-success">Active</span>
          ) : (
            <span className="badge text-bg-danger">Deactivated</span>
          )}
        </div>
      ),
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      render: (_, row) => (
        <div className="actions">
          <Link to={`/assign-plan?b=` + row?.business?._id} className="btn btn-edit me-1">
            <FiEdit title="Edit Assigned Plan" />
          </Link>
          {(() => {
            switch (row.isActive) {
              case true:
                return (
                  <button className="btn btn-warning  me-1" onClick={() => activeDeactivePlan(row._id, row.isActive)}>
                    <FiUserX title="Deactivate Subscription" />
                  </button>
                );
              case false:
                return (
                  <button className="btn btn-success  me-1" onClick={() => activeDeactivePlan(row._id, row.isActive)}>
                    <FiUserCheck title="Activate Subscription" />
                  </button>
                );
              default:
                return;
            }
          })()}
          <button className="btn btn-danger" title="Delete" onClick={() => deletePlan(row._id)}>
            <FiTrash />
          </button>
        </div>
      ),
      width: 160,
    },
  ];

  const activeDeactivePlan = async (planId, isActive) => {
    const data = {
      isActive: !isActive,
    };
    Swal.fire({
      title: "Are you sure?",
      text: isActive
        ? `This action will deactivate the business from the current subscription plan.`
        : "This action will activate the business's previous subscription plan.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .put(`/subscription/assign-plan/` + planId, data, {
            withCredentials: true,
          })
          .then(() => {
            getSubscriptionSummary();
            Swal.fire({
              title: "Done!",
              text: "Assign Plan Status Successfully Changed",
              icon: "success",
              timer: 2000,
              button: false,
            });
          });
      }
    });
  };

  const deletePlan = async (subscriptionId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this site user?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/subscription/assign-plan/` + subscriptionId, {
            withCredentials: true,
          })
          .then(() => {
            getSubscriptionSummary();
            Swal.fire({
              title: "Done!",
              text: "Plan Successfully Deleted",
              icon: "success",
              timer: 2000,
              button: false,
            });
          });
      }
    });
  };

  return (
    <div className="az-content-body p-0 px-md-3">
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header">
              <div>
                <label className="az-content-label">Manage Subscriptions</label>
                <span className="d-block py-2">Business Subscription Summary</span>
              </div>
            </div>
            <div className="row mb-3 g-3">
              <div className="col-md-3">
                <Select
                  onChange={(value) => setSearchValue({ ...searchValue, planType: value })}
                  value={searchValue?.planType || ""}
                  size="large"
                  style={{ width: "100%" }}
                  required
                >
                  <Select.Option value="">All Plan Type</Select.Option>
                  <Select.Option value="Paid">Paid</Select.Option>
                  <Select.Option value="Free">Free</Select.Option>
                </Select>
              </div>
              <div className="col-md-3">
                <Select
                  onChange={(value) => setSearchValue({ ...searchValue, subscriptionType: value })}
                  value={searchValue?.subscriptionType || ""}
                  size="large"
                  style={{ width: "100%" }}
                  required
                >
                  <Select.Option value="">All Subscription Type</Select.Option>
                  <Select.Option value="Business">Business</Select.Option>
                  <Select.Option value="Personal">Personal</Select.Option>
                  <Select.Option value="NGO / Not-for-Profit">NGO / Not-for-Profit</Select.Option>
                  <Select.Option value="Partnership">Partnership</Select.Option>
                </Select>
              </div>

              <div className="col-md-2">
                <button
                  className="btn bg-secondary-subtle text-black"
                  onClick={() => {
                    getSubscriptionSummary();
                  }}
                >
                  <FaSearch />
                </button>
              </div>
              <div className="col-md-2"></div>

              <div className="col-md-2 text-right">
                <Input
                  placeholder="Search"
                  size="large"
                  name="searchText"
                  onChange={(e) => setSerachText(e.target.value)}
                />
              </div>
            </div>

            <Spin spinning={isLoading}>
              <DataTable
                dataSource={subscriptionSummary}
                columns={columns}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: 10,
                  current: page,
                  total,
                  showSizeChanger: true,
                  onShowSizeChange: (_, pageSize) => {
                    setLimit(pageSize);
                  },
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                  pageSizeOptions: [10, 20, 50],
                  responsive: true,
                }}
                onChange={(pagination) => {
                  setPage(pagination.current);
                }}
              />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSummary;
